import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface Props {
  pages: Array<{ slug: string; title: string; neighborhood: string | null; city: string | null }>;
}

export function RelatedGuides({ pages }: Props) {
  if (!pages.length) return null;
  return (
    <section>
      <h2 className="font-serif text-2xl font-semibold text-foreground sm:text-3xl">
        More work-friendly café guides
      </h2>
      <ul className="mt-5 grid gap-3 sm:grid-cols-2">
        {pages.map((p) => (
          <li key={p.slug}>
            <Link
              to={`/best-cafes/${p.slug}`}
              className="group flex items-center justify-between rounded-xl border border-border bg-card p-4 transition hover:border-[hsl(var(--seal-gold))]"
            >
              <div>
                <div className="font-medium text-foreground">{p.title}</div>
                {p.city && (
                  <div className="text-xs text-muted-foreground">{p.city}</div>
                )}
              </div>
              <ArrowRight className="h-4 w-4 text-muted-foreground transition group-hover:translate-x-0.5 group-hover:text-foreground" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
